<template>
  <div>
    <a
      v-show="showPlayButton"
      v-tooltip.left="'Preview'"
      href="javascript:;"
      class="recording-cell__btn"
      @click="showAudioPlayer"
    >
      <i
        v-if="iconButton"
        class="fa fa-play"
      />

      <button
        v-if="!iconButton"
        type="button"
        class="btn btn-primary"
        :disabled="disabled"
      >
        {{ $t('PREVIEW') }}
      </button>
    </a>

    <AudioPlayer 
      v-if="audioInfo" 
      ref="audioPlayer" 
      :audio-info="audioInfo"
      :fixed-player="fixedPlayer"
      :no-float="noFloat"
      @hidePlayer="hidePlayer"
    />
  </div>
</template>

<script>
import AudioPlayer from '@/core/components/AudioPlayer/AudioPlayer';
import messages from '../locales';

export default {
  components: {
    AudioPlayer
  },
  props: {
    recordingUrl: {
      type: String,
      default: '',
    },
    fixedPlayer: {
      type: Boolean,
      default: false
    },
    noFloat: {
      type: Boolean,
      default: false
    },
    iconButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      audioInfo: null,
      showPlayButton: true
    };
  },
  methods: {
    togglePlayButton() {
      this.showPlayButton = !this.showPlayButton;
    },
    stopAudioPlayer() {
      this.$refs.audioPlayer?.resetPlayer();
    },
    showAudioPlayer() {
      this.$refs.audioPlayer?.resetPlayer();
      this.togglePlayButton();
      this.audioInfo = {
        recordingUrl: this.recordingUrl,
      };
    },
    hidePlayer() {
      this.audioInfo = null;
      this.showPlayButton = true;
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>